module.exports = __webpack_public_path__ + "src/assets/img/mft-logo__green.53c5d364.svg";